export function setProgress(element, percent) {
  element.style.setProperty("--value", percent)
  element.setAttribute("aria-valuenow", percent)
  element.textContent = `${percent}%`
}
